import { WrapperGS } from '../core/WrapperGS';

export class LabelGS extends WrapperGS<HTMLLabelElement>
{
    static ForHTMLElement(el: HTMLElement): boolean {
        return el.nodeName.toLowerCase() === "label";
    }

    constructor(el: HTMLLabelElement|string)
    {
        super(el);
    }

    public get htmlFor() { return this.el.htmlFor; }
    public set htmlFor(value: string) { this.el.htmlFor = value; }

    public get control(): WrapperGS | undefined {
        return this.el.control ? WrapperGS.Wrap(this.el.control) : undefined;
    }
}
WrapperGS.ExtendComponentsByHTMLElement(LabelGS);
